import { motion } from "framer-motion";
import { EMOJIS } from "../lib/api";

export const EmojiScale = ({ value, onChange, compact }) => (
  <div data-testid="emoji-scale">
    {!compact && (
      <div className="flex items-baseline justify-between gap-3 mb-3 text-[11px] sm:text-xs uppercase tracking-[0.12em] sm:tracking-[0.25em] text-[var(--muted)]">
        <span className="shrink-0 whitespace-nowrap">Beoordeel · 1 — 10</span>
        <span data-testid="rating-step-label" className="text-right whitespace-nowrap text-[var(--paper)]">
          {value ? `${value}/10 · ${EMOJIS[value - 1].label}` : "10 stappen van tevredenheid"}
        </span>
      </div>
    )}
    <div className={`grid grid-cols-5 lg:grid-cols-10 ${compact ? "gap-1" : "gap-2 sm:gap-3"}`}>
      {EMOJIS.map((item, i) => {
        const n = i + 1;
        const active = value === n;
        return (
          <motion.button
            key={n}
            type="button"
            data-testid={`emoji-rating-btn-${n}`}
            aria-label={`${n} – ${item.label}`}
            onClick={() => onChange(n)}
            initial={{ opacity: 0, y: 24, rotateX: -60 }}
            animate={{ opacity: value && !active ? 0.45 : 1, y: 0, rotateX: 0 }}
            whileHover={{ y: -6, scale: 1.08 }}
            whileTap={{ scale: 0.9 }}
            transition={{ delay: 0.5 + i * 0.04, type: "spring", stiffness: 300, damping: 18 }}
            className={`relative flex flex-col items-center justify-center rounded-2xl border transition-colors ${
              compact ? "py-1" : "py-2 sm:py-3"
            } ${active ? "border-[var(--amber)] bg-[rgba(255,181,71,0.15)]" : "border-[var(--line)] bg-[var(--ink-2)] hover:border-[var(--paper)]/40"}`}
          >
            <span className={compact ? "text-xl" : "text-[clamp(1.5rem,4.2vh,2.4rem)]"}>{item.e}</span>
            {!compact && <span className="font-mono-clock text-[11px] text-[var(--muted)] mt-1">{String(n).padStart(2, "0")}</span>}
            {active && (
              <motion.span layoutId="emoji-ring" className="absolute -inset-[3px] rounded-[1.1rem] border-2 border-[var(--amber)]" />
            )}
          </motion.button>
        );
      })}
    </div>
  </div>
);
